import LoadableError from './loadableError.component';

export default LoadableError;
